import { render, staticRenderFns } from "./LottieMacroAniHandler.vue?vue&type=template&id=4b32e624&scoped=true&"
import script from "./LottieMacroAniHandler.vue?vue&type=script&lang=js&"
export * from "./LottieMacroAniHandler.vue?vue&type=script&lang=js&"
import style0 from "./LottieMacroAniHandler.vue?vue&type=style&index=0&id=4b32e624&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b32e624",
  null
  
)

export default component.exports